/* eslint-disable max-len */
import React from 'react';
import Icon from '@avtechsoftware/react-component-library/src/components/common/Icon/Icon';
import PropTypes from 'prop-types';

function RegistrationEmailSent({ isOrder }) {
  return (
    <div className="card bg-light" style={{ minHeight: '4rem', maxWidth: '45rem' }}>
      <h5 className="card-header">{isOrder ? 'Submit Payment' : 'Place your Order'}</h5>
      <div className="card-body">
        <div className="pb-3">
          <h5 className="card-title">
            <Icon icon="envelope" />
            {' '}
            Registration Email Sent

          </h5>
          <div className="card-text">
            An account registration request has been sent to your email. Check the link in the message to validate your account.
          </div>
        </div>
      </div>
    </div>
  );
}

RegistrationEmailSent.propTypes = {
  isOrder: PropTypes.bool.isRequired,
};

export default RegistrationEmailSent;
